// @ts-check
import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';

import { documentRolesSchema } from '@/data/schema/documents';
import { fieldsSchema } from '@/data/schema/documents/fields';

export const documentSchema = z.object({
  id: z.number(),
  contract_id: z.number(),
  fingerprint: z.string(),
  title: z.string(),
  order: z.number(),
  total_pages: z.number().nullable(),
  is_template: z.coerce.boolean().nullable(),
  processed_at: Timestamp,
  images: z.array(z.string()),
  parties: documentRolesSchema,
  fields: fieldsSchema,
});

export const documentsSchema = documentSchema.array();

export const documentSummarySchema = documentSchema
  .pick({
    fingerprint: true,
    title: true,
    order: true,
    is_template: true,
  })
  .extend({
    fields: documentSchema.shape.fields.transform(val => val?.length ?? 0),
  });
export const documentSummariesSchema = documentSummarySchema.array();

export const currentDocumentSchema = documentSchema.pick({
  fingerprint: true,
  title: true,
  order: true,
  is_template: true,
});
export const currentDocumentsSchema = currentDocumentSchema.array();

const Order = z.object({
  order: z.number(),
});
export const updateDocumentSchema = Order.extend({
  document_fingerprint: z.string(),
})
  .or(Order.extend({ template_fingerprint: z.string() }))
  .or(Order.extend({ file: z.instanceof(File) }));

export const updateDocumentsSchema = updateDocumentSchema.array();

/** @typedef {z.infer<typeof documentSchema>} TDocument */
/** @typedef {z.infer<typeof documentsSchema>} TDocuments */
/** @typedef {z.infer<typeof documentSummariesSchema>} TDocumentSummaries */
/** @typedef {z.infer<typeof currentDocumentSchema>} TCurrentDocument */
/** @typedef {z.infer<typeof currentDocumentsSchema>} TCurrentDocuments */
/** @typedef {z.infer<typeof updateDocumentSchema>} TUpdateDocument */
/** @typedef {z.infer<typeof updateDocumentsSchema>} TUpdateDocuments */
